// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2jC_m","box":"WorkspacesBox_box__24sJG","node":"WorkspacesBox_node__fdaxZ"};